var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"text-2xl text-black dark:text-white"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }